import React, { Component } from 'react';
import { withRouter, Redirect } from 'react-router-dom';
import REST from '../Shared/REST';
import queryString from "query-string";
import {connect} from "react-redux";
import {userLogout} from "../TeachersComponent/actions";

class MainComponent extends Component {

    constructor(props){
        super(props);
    }

    async componentDidMount() {
        const parsed = queryString.parse(this.props.location.search);
        if(parsed.emailGUID && parsed.emailGUID!==""){
            localStorage.removeItem('token');
            localStorage.clear();
            await this.props.persistor.purge();
            await this.props.userLogout();
            await localStorage.setItem('emailGUID', parsed.emailGUID);
            this.props.history.push("/");
        }else{
            let token = localStorage.getItem('token');
            if (token) {
                await REST.authWithToken().then((response) => {
                    if (response.success) {
                        this.props.userCallback(response.body);
                        this.props.history.push('/' + response.body.role);
                    }
                    else {
                        this.props.history.push('/login');
                    }
                }, (error) => {
                    alert(error);
                    this.props.history.push('/login');
                });
            }
        }
    }

    render() {
        let token = localStorage.getItem('token');
        if (!token) {
            return <Redirect to="/login" />;
        }
        else {
            return <h1>Loading...</h1>;
        }
    }
}

const bindActionToProps = dispatch => {
    return {
        userLogout: async() => await dispatch(userLogout())
    };
};


const mapStateToProps = state => ({
    lastClass: state.teacherReducer.lastClass,
    lastStudent: state.teacherReducer.student
});

export default connect(mapStateToProps,bindActionToProps)(withRouter(MainComponent));



// WEBPACK FOOTER //
// ./src/MainComponent/Main.js